export var LocalConsentStatus = /*#__PURE__*/function (LocalConsentStatus) {
  LocalConsentStatus["STATUS_DEFAULT"] = "-1";
  LocalConsentStatus["STATUS_ONLY_NECESSARY"] = "0";
  LocalConsentStatus["STATUS_NOT_YET_ANSWERED"] = "1";
  LocalConsentStatus["STATUS_ACCEPTED"] = "2";
  return LocalConsentStatus;
}({});
export var AvailableConsentPermissions = /*#__PURE__*/function (AvailableConsentPermissions) {
  AvailableConsentPermissions["SECURITY_STORAGE"] = "security_storage";
  AvailableConsentPermissions["FUNCTIONALITY_STORAGE"] = "functionality_storage";
  AvailableConsentPermissions["PERSONALISATION_STORAGE"] = "personalization_storage";
  AvailableConsentPermissions["ANALYTICS_STORAGE"] = "analytics_storage";
  AvailableConsentPermissions["AD_PERSONALISATION"] = "ad_personalization";
  AvailableConsentPermissions["AD_USER_DATA"] = "ad_user_data";
  AvailableConsentPermissions["AD_STORAGE"] = "ad_storage";
  return AvailableConsentPermissions;
}({});
export var ConsentEventOption = /*#__PURE__*/function (ConsentEventOption) {
  ConsentEventOption["GRANTED"] = "granted";
  ConsentEventOption["DENIED"] = "denied";
  return ConsentEventOption;
}({});